import axios, {AxiosResponse, AxiosError} from 'axios';

// 定义一个泛型接口，表示请求的响应数据类型
interface ResponseData<T> {
    code: string;
    message: string;
    data: T;
}

// 封装一个公共的 HTTP 请求类
class HttpClient {
    // 基础的 API 地址
    baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
        // 设置Axios全局默认的请求头
        // const token = localStorage.getItem("token");
        // if (token != undefined && token != null) {
        //     axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        // }
    }

    // 封装 GET 请求方法1
    public async get(url: string): Promise<any> {
        try {
            const response: AxiosResponse<ResponseData<any>> = await axios.get<ResponseData<any>>(url);
            return response.data; // 返回响应数据的 data 字段
        } catch (error) {
            throw this.handleError(error as AxiosError);
        }
    }

    // 封装 POST 请求方法
    public async post(url: string, form: any): Promise<any> {
        try {
            const response: AxiosResponse<ResponseData<any>> = await axios.post<ResponseData<any>>(url, form);
            return response.data; // 返回响应数据的 data 字段
        } catch (error) {
            throw this.handleError(error as AxiosError);
        }
    }

    // 封装错误处理方法
    private handleError(error: AxiosError): Error {
        if (error.response) {
            // 请求发出，但服务器返回状态码不在 2xx 范围内
            return new Error(`请求错误：${error.response.status} - ${error.response.statusText}`);
        } else if (error.request) {
            // 请求发出但未收到响应
            return new Error('请求未收到响应，请检查网络连接或服务器是否正常运行。');
        } else {
            // 在设置请求时发生了一些问题，触发了一个错误
            return new Error(`请求设置错误：${error.message}`);
        }
    }
}

export default HttpClient;
